import { gql } from '@apollo/client';

export const CREATE_DAILY_MEETING_ATTRIBUTION = gql`
    mutation CreateDailyMeetingAttribution($input: CreateDailyMeetingAttributionInput!) {
        createDailyMeetingAttribution(input: $input) {
            id
            warehouseId
            statDate
            reason
            notes
            expectedRecoveryDate
            claimStatus
            claimerId
            claimerName
            creatorId
            creatorName
            updatedById
            updatedByName
            createdAt
            updatedAt
        }
    }
`;
